import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=684a2812&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=684a2812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a2812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684a2812')) {
      api.createRecord('684a2812', component.options)
    } else {
      api.reload('684a2812', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=684a2812&scoped=true&", function () {
      api.rerender('684a2812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eNDdL0hWFzYT/JS/pricehelp.vue"
export default component.exports